<template>
  <v-select :items="options" label="Select">
    <template v-slot:append>
      <ns-icon icon-name="icon-chevron-down" height="20" width="20" />
    </template>
  </v-select>
</template>

<script>
import NsIcon from "../icons/NsIcon.vue";
import { VSelect } from "vuetify/lib";

export default {
  name: "NsSelect",
  components: { NsIcon, VSelect },
  props: {
    options: Array,
    hideDetails: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      items: []
    };
  }
};
</script>
<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/buttons";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";


::v-deep * {
  $color-dryink: map.get(typographyVariables.$typography, font-family-primary);
}
</style>